import { supabaseConfig } from "../lib/supabase";

/**
 * Visible warning when env vars are missing — much friendlier than a blank
 * page. Only renders when Supabase config is incomplete, so it disappears
 * automatically once `.env` is wired up.
 */
export function ConfigBanner(): JSX.Element | null {
  if (supabaseConfig.isConfigured) return null;
  return (
    <div className="banner banner--error" role="alert" style={{ margin: "0 auto 16px", maxWidth: 460 }}>
      <span aria-hidden="true">!</span>
      <div>
        <strong>Configuration required.</strong> Missing env: <code>{supabaseConfig.missing.join(", ")}</code>.
        <br />
        Copy <code>.env.example</code> to <code>.env</code>, fill in the Supabase URL and anon key, then restart the dev
        server.
      </div>
    </div>
  );
}
